import { getRequest } from "NetworkCall";
import { INSTANCE_URL } from "Constants";
import _ from "lodash";

export const SOCIALFEED_TOTAL_POST = "SOCIALFEED_TOTAL_POST";

export function socialfeedpostcount(session, callback) {
  // debugger;

  var url = `${INSTANCE_URL}/api/v2/analytics?type=socialfeedpostcnt&eventid=${session.eventid}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        // debugger;

        var data = response;

        //Prepare data for Device Installs..

        dispatch({ type: SOCIALFEED_TOTAL_POST, payload: data });

        callback({ error: 0, data: "Analytics Data Fetched" });
      },
      (error) => {
        callback({ error: 1, data: null });
      }
    );
  };
}
